import { supabase } from './supabase';

type JoinResult = { ok: true } | { ok: false; error: string };

export async function joinWaitlist(rawEmail: string): Promise<JoinResult> {
  const email = rawEmail.trim().toLowerCase();

  if (!isValidEmail(email)) {
    return { ok: false, error: 'Enter a valid email.' };
  }

  const { error } = await supabase
    .from('waitlist_signups')
    .insert({ email, source: 'landing' });

  if (error) {
    // 23505 = unique_violation. Treat dupes as success — the user is on the list.
    if (error.code === '23505') return { ok: true };
    return { ok: false, error: 'Something went wrong. Try again in a moment.' };
  }

  return { ok: true };
}

function isValidEmail(v: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
}
